import type { LinkComponent, SDSProvidedLinkProps } from '@repo/sds/providers/SDSProvider/types';

// THE CORRECT DEFAULT LINK: Uses forwardRef.
// This is critical for robustness.
export const DefaultLink: LinkComponent = ({ children, ref, ...props }: SDSProvidedLinkProps) => (
  <a {...props} ref={ref}>
    {children}
  </a>
);
